import * as React from 'react';
import { Link } from 'react-router-dom';
import Intro from './Intro';
import ApplicationForm from './ApplicationForm';
import Payment from './Payment';
import Dashboard from './Dashboard';
import SignUpForm from './SignUpForm';
import { SignUpInfo } from '../../models';
import { i18n } from '../../i18n';

interface SwiperState {
  currentIndex: number,
  translateX: number
}

interface NextStepsProps {
  signUp: (info: SignUpInfo) => object,
  signUpError: string,
  hasSubmitted: boolean
}

const calculateTranslateX = (width: number, index: number) => (index * width) * -1;
const measureSlideWidth = (): number => {
  const slideEl = document.querySelector('.swipe-wrap')

  if (!slideEl) {
    return 0;
  }

  return slideEl.clientWidth;
};
const isOutOfBounds = (start: number, end: number) => (index: number) => index >= end || index < start;

export default class NextSteps extends React.Component<NextStepsProps> {
  public state: SwiperState;
  public slideWidth: number;
  public numberOfSlides: number;
  public shouldCancelSwipe: (x: number) => boolean;
  public slideIndexes: number[];
  public lastInteractionXpos: number;
  public lastInteractionYpos: number;

  public constructor(props: NextStepsProps) {
    super(props);
    this.numberOfSlides = 4;

    this.shouldCancelSwipe = isOutOfBounds(0, this.numberOfSlides);
    this.slideIndexes = Array.from({length: this.numberOfSlides}, (x,i) => i);

    this.state = {
      currentIndex: 0,
      translateX: 0
    };

    this.swipeStart = this.swipeStart.bind(this);
    this.swipeEnd = this.swipeEnd.bind(this);
    this.touchStart = this.touchStart.bind(this);
    this.touchEnd = this.touchEnd.bind(this);
    this.dragStart = this.dragStart.bind(this);
    this.dragEnd = this.dragEnd.bind(this);
    this.slideWidth = 0
    this.lastInteractionXpos = 0
    this.lastInteractionYpos = 0
  }

  public componentDidMount() {
    this.slideWidth = measureSlideWidth();
  }

  public render() {
    return (
      <div className='content-wrap next-steps'>
        <div className='content-header'>
          <h1 className='title-underline'>{i18n.t('next_steps.heading')}</h1>
        </div>

        <div className='sign-up-wrap'>
          <SignUpForm signUp={this.props.signUp} signUpError={this.props.signUpError} hasSubmitted={this.props.hasSubmitted} />
        </div>

        <div
          className='swipe-wrap'
          onTouchStart={this.touchStart}
          onTouchEnd={this.touchEnd}
          onMouseDown={this.dragStart}
          onMouseUp={this.dragEnd}
        >
          <div className='swipables' style={{
            transform: `translateX(${this.state.translateX}px)`
          }}>
            <Intro />
            <ApplicationForm />
            <Payment />
            <Dashboard />
          </div>

          <div className='content-navigation'>
            {
              this.slideIndexes.map((index) => (
                <button
                  key={index}
                  className={`button ${index === this.state.currentIndex ? 'active' : ''}`}
                  onClick={this.onNavClick(index)}
                />)
              )
            }
          </div>

          <Link className='button back-button' to={{ pathname: '/' }}>
          {i18n.t('next_steps.back_button_text')}
          </Link>
        </div>
      </div>
    );
  }

  private onNavClick = (index: number) => () => this.transition(index);

  private transition(index: number) {
    if (this.shouldCancelSwipe(index)) {
      return;
    }

    this.setState({
      currentIndex: index,
      translateX: calculateTranslateX(this.slideWidth, index)
    })
  }

  private touchStart(event: React.TouchEvent) {
    this.swipeStart(
      event.changedTouches[0].clientX,
      event.changedTouches[0].clientY
    );
  }

  private touchEnd(event: React.TouchEvent) {
    this.swipeEnd(
      event.changedTouches[0].clientX,
      event.changedTouches[0].clientY
    );
  }

  private dragStart(event: React.MouseEvent) {
    this.swipeStart(event.clientX, event.clientY);
  }

  private dragEnd(event: React.MouseEvent) {
    this.swipeEnd(event.clientX, event.clientY);
  }

  private swipeStart(newXpos: number, newYpos: number) {
    this.lastInteractionXpos = newXpos;
    this.lastInteractionYpos = newYpos;
  }

  private swipeEnd(newXpos: number, newYpos: number) {
    const threshold = 15;
    const xDelta = newXpos - this.lastInteractionXpos;
    const yDelta = newYpos - this.lastInteractionYpos;
    const isVerticalSwipe = Math.abs(xDelta) < Math.abs(yDelta);

    if (isVerticalSwipe || Math.abs(xDelta) < threshold) {
      return;
    }

    this.swipe(xDelta > 0 ? 'left' : 'right');
  }

  private swipe(direction: 'left' | 'right') {
    const newIndex = direction === 'left' ? this.state.currentIndex - 1 : this.state.currentIndex + 1;

    if (this.shouldCancelSwipe(newIndex)) {
      return;
    }

    this.transition(newIndex);
  }
}
